import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Layers, CheckCircle2, XCircle, Clock } from "lucide-react";
import { api, eur } from "@/lib/apiClient";

const ESITO = {
  accettato: { label: "Accettato", icon: CheckCircle2, cls: "text-terracotta" },
  non_accettato: { label: "Lasciato dal cliente", icon: XCircle, cls: "text-red-600" },
  in_attesa: { label: "In attesa di risposta", icon: Clock, cls: "text-amber-700" },
};
const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT") : "—");

// Esito della proposta unica (trattativa multi-prodotto) di cui fa parte il preventivo.
export function ProposalUnicaEsito({ tid, currentId }) {
  const [d, setD] = useState(null);
  useEffect(() => { if (tid) api.get(`/trattative/${tid}/esito`).then(({ data }) => setD(data)).catch(() => setD(null)); }, [tid]);
  if (!tid || !d) return null;
  const acc = d.accettazione;
  return (
    <div className="rounded-2xl border border-forest/15 bg-sage/60 p-5" data-testid="proposta-unica-esito">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2 font-heading text-lg font-semibold text-forest"><Layers className="h-5 w-5" /> Proposta unica</div>
        <div className="text-xs text-muted-foreground" data-testid="pu-esito-dates">
          Inviata il {fmt(d.inviata_at)} · {d.aperta_at ? `aperta il ${fmt(d.aperta_at)}` : "non ancora aperta"}{acc ? ` · confermata il ${fmt(acc.at)}${acc.canale?.startsWith("otp") ? " con OTP" : " online"}` : ""}
        </div>
      </div>
      <div className="mt-3 space-y-1.5">
        {d.items.map((it) => {
          const e = ESITO[it.esito];
          return (
            <Link key={it.id} to={`/preventivi/${it.id}`} data-testid={`pu-esito-item-${it.id}`}
              className={`flex items-center justify-between rounded-lg bg-white px-3 py-2 text-sm transition-shadow hover:shadow ${it.id === currentId ? "ring-1 ring-forest/40" : ""}`}>
              <span className="font-medium text-forest">{it.product_name}{it.codice_prev ? <span className="text-muted-foreground"> · {it.codice_prev}</span> : null}</span>
              <span className="flex items-center gap-3"><span className="text-xs text-muted-foreground">{eur(it.premio)}</span>
                <span className={`flex items-center gap-1 text-xs font-semibold ${e.cls}`} data-testid={`pu-esito-${it.id}`}><e.icon className="h-3.5 w-3.5" />{e.label}</span></span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
